import { Box, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export default function GoalsDataDisclaimer() {
  return (
    <Box sx={{ display: "flex", alignItems: "flex-start", gap: 0.75, mb: 1.5 }}>
      <InfoOutlinedIcon sx={{ fontSize: 15, color: "#D96B04", mt: "1px" }} />
      <Typography sx={{ fontSize: 12, fontWeight: 500, color: "#D96B04", lineHeight: 1.4 }}>
        Goal values shown are from the previous quarter, as the goals for the current quarter are not
        yet available
      </Typography>
    </Box>
  );
}
